module.exports = __webpack_public_path__ + "static/favicon200-dcd1123e94a88b7e3602af9c33bd8a5e.png";